import { provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
// ─────────────────────────────────────────────────────────────────────────────
import { ConfigLoader } from './config-loader';

async function startApp() {
  // Initialize environment config
  await ConfigLoader.load();

  // Use the bootstrapApplication from the standalone approach
  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZonelessChangeDetection(), ...appConfig.providers],
  }).catch((err) => console.error(err));
}

startApp();
